import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../verticals/hotels-dweb/src/shared/store';
import {xhrHelper} from '../../../verticals/hotels-dweb/src/shared/utils/xhrHelper';
import axios from 'axios';
import getUserReviews from '@stencil/get-user-reviews';
import getReviewsSnapshotData from '@stencil/get-reviews-snapshot-data';
import getMoreTravellerImages from '@stencil/get-traveller-images';

import {
  updateMoreImages,
  updateHasMoreImages,
  updateReviewDataStatus,
  updateHasDataAction,
  setSnapDataAction,
  updateHasUserReview,
  updateUserReview,
  setQNAFilters,
  updateQnaDataStatus,
  updateHasQnaDataAction,
  setQNAData,
  setUserReviewsLoadingState,
  updateSnapshotDataFetchStatus,
} from './hotels-ugc-actions';

import {
  QNADataType,
  QuesDetailType,
  ReviewDataList,
  SnapDataType,
  FetchStatusType,
} from './hotels-ugc-types';
// for traveller images in image gallery popup
var ajaxCallLocked;
ajaxCallLocked = false;
export const fetchMoreImages = (
  hotelId,
  offset,
  limit,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>) => {
    try {
      ajaxCallLocked = true;
      const response: Array<any> = await getMoreTravellerImages(hotelId, offset, limit);
      if (response && Array.isArray(response) && response.length) {
        dispatch(updateHasMoreImages(true));
        dispatch(updateMoreImages(response));
        if (response.length > 0) {
          ajaxCallLocked = false;
        }
      } else {
        dispatch(updateHasMoreImages(false));
        ajaxCallLocked = false;
      }
    } catch {
      dispatch(updateHasMoreImages(false));
      ajaxCallLocked = false;
    }
  };
};

//fetch rating overview data of RNR
export const fetchSnapData = (hotelId): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateReviewDataStatus(true));
    dispatch(updateSnapshotDataFetchStatus(FetchStatusType.PENDING));
    const {srp} = getState();
    const {filter = {}} = srp.srpConfig;
    let idf = filter.hctx ? 'segment' : '',
      val = filter.hctx ? filter.hctx : '';

    // Invoke API
    try {
      const response: SnapDataType = await getReviewsSnapshotData(hotelId, idf, val);
      if (response) {
        dispatch(updateHasDataAction(true));
        dispatch(updateReviewDataStatus(false));
        dispatch(setSnapDataAction(response));
        dispatch(updateSnapshotDataFetchStatus(FetchStatusType.RESOLVED));
      }
    } catch {
      dispatch(updateHasDataAction(false));
      dispatch(updateSnapshotDataFetchStatus(FetchStatusType.REJECTED));
    }
  };
};

//to fetch user reviews in RNR
export const fetchUserReviews = (
  hotelId,
  offset,
  limit,
  tagIds = [],
  filter,
  sortBy,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {ugc} = getState();

    const {searchText, reviewId} = ugc.reviewDetailType;
    dispatch(setUserReviewsLoadingState(true));
    try {
      const response: ReviewDataList = await getUserReviews(
        hotelId,
        offset,
        limit,
        tagIds,
        filter,
        sortBy,
        searchText,
        reviewId,
      );
      if (response && Array.isArray(response.reviews) && response.reviews.length) {
        dispatch(updateUserReview(response));
        dispatch(setUserReviewsLoadingState(false));
        // Used in case of pagination of reviews (Discrepancy at UGC count and actual data)
        dispatch(updateHasUserReview(true));
      } else {
        dispatch(updateUserReview({}));
        dispatch(setUserReviewsLoadingState(false));
        dispatch(updateHasUserReview(true));
      }
    } catch {
      dispatch(updateUserReview({}));
      dispatch(updateHasUserReview(false));
      dispatch(setUserReviewsLoadingState(false));
    }
  };
};

// For Qna filter list
export const getQnaFilters = (id, type): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    const url = 'https://ugc.goibibo.com/api/Questions/getQuestionFilter';
    const options = {
      params: {
        id: id,
        type: type,
      },
    };

    axios
      .get(url, options)
      .then(response => {
        let data = [];
        if (response && response.data) {
          data = response.data;
          dispatch(setQNAFilters(data));
        }
      })
      .catch(err => {
        console.log('Filter Qna API call failed');
        console.trace(err);
        dispatch(setQNAFilters([]));
      });
  };
};

//Fetch Qna data
export const fetchQnA = (
  hotelId,
  offset,
  limit,
  sortBy,
  filter,
): ThunkAction<void, AppState, {}, AnyAction> => {
  // Invoke API
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    // getState()
    let url = `https://ugc.goibibo.com/api/Questions/getHotelQuestionsWeb/?offset=${offset}&limit=${limit}&vid=${hotelId}`;

    if (sortBy.length) url += '&sortBy=' + sortBy;
    if (filter.length > 0) {
      url += '&filters=[' + filter + ']';
    }

    xhrHelper({
      name: 'QnA API',
      type: 'GET',
      url: url,
    })
      .then(response => {
        if (response && response.data) {
          let data = response.data as QNADataType;
          dispatch(updateQnaDataStatus(false));
          dispatch(setQNAData(data));
          if (data.data && data.data.length > 0) {
            dispatch(updateHasQnaDataAction(true));
          }
        }
      })
      .catch(() => {
        dispatch(setQNAData({} as QNADataType));
      });
  };
};

//Get Particular question detail in QNA
export function getQuesDetails({qid, hFilter = false}, cb) {
  const url =
    'https://ugc.goibibo.com/api/Questions/' + qid + '/getQuestionDetailV2?hFilter=' + hFilter;

  xhrHelper({
    name: 'Question Detail API',
    type: 'GET',
    url: url,
  })
    .then(response => {
      if (response && response.data) {
        let data = response.data as QuesDetailType;
        return cb(data);
      }
    })
    .catch(err => {
      console.log('Detail Qna API call failed');
      console.trace(err);
      return cb([]);
    });
}
